import { Component, OnInit } from '@angular/core';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

// Shared with app.routes.ts (route path) and val-auth.service.ts (which must not run any
// MSAL API calls of its own while this page is active - see the component doc comment below).
export const MSAL_REDIRECT_BRIDGE_PATH = 'auth';

// Microsoft Entra ID enables Cross-Origin-Opener-Policy by default, which blocks the
// classic popup/iframe polling msal-browser used before v5. This page is the redirectUri
// MSAL sends the auth response to: for popup/silent flows it broadcasts the response back
// to the opener window over BroadcastChannel; for redirect flows it caches the response and
// navigates back to the page that started the login, where handleRedirectObservable() picks
// it up as before. It must stay outside MsalGuard and must not call any other MSAL APIs.
@Component({
  standalone: true,
  selector: 'val-redirect-bridge',
  template: '<p>Signing in...</p>'
})
export class ValRedirectBridgeComponent implements OnInit {
  ngOnInit(): void {
    broadcastResponseToMainFrame().catch((error: Error) => {
      console.error('Error broadcasting MSAL response to main frame:', error);
    });
  }
}
